/**
 * Установка начального состояния.
 * Вынужден опрелять в каждом модуле, т.к. Vuex не позволяет модифицировать state одних модулей из других.
 * @type {string}
 */
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE'

export const PUT_TO_CART = 'PUT_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'

export const CREATE_ORDER = 'CREATE_ORDER'



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/store/mutation-types.js